import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Select from 'react-select';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../action';
import * as c from '../constant';
import NewDeclarationContainer from './new-declaration/NewDeclarationContainer';
import TransferOfOwnershipContainer from './transfer-of-ownership/TransferOfOwnershipContainer';
import SubdivisionContainer from './subdivision/SubdivisionContainer';
import DisputeContainer from './dispute/DisputeContainer';
import ReclassificationContainer from './reclassification/ReclassificationContainer';
import PhysicalChangeContainer from './physical-change/PhysicalChangeContainer';
import DestructionContainer from './destruction/DestructionContainer';
import ConsolidationContainer from './consolidation/ConsolidationContainer';

function TransactionModal({ getTransactionCodesList, transactionList }) {
  useEffect(() => {
    getTransactionCodesList();
  }, []);

  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState({
    rptax_transaction_code_id: '',
  });

  const validateForm = useFormValidator(formData, {
    rptax_transaction_code_id: 'required',
  });

  const createDropdownRpt = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.id,
        code: data.attributes.code,
      });
    });
    return newList;
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
      transaction_code: e ? e.code : '',
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (formData.transaction_code === 'DC') {
      setModal({
        isOpen: true,
        content: (
          <NewDeclarationContainer
            transactionCode={formData.rptax_transaction_code_id}
            modalType="NEW"
          />
        ),
        title: 'New Declaration (Discovery)',
        modalSize: 'modal-xl',
      });
    }
    if (formData.transaction_code === 'SD') {
      setModal({
        isOpen: true,
        content: (
          <SubdivisionContainer
            transactionCode={formData.rptax_transaction_code_id}
          />
        ),
        title: 'Subdivision',
        modalSize: 'modal-xl',
      });
    }
    if (formData.transaction_code === 'CS') {
      setModal({
        isOpen: true,
        content: (
          <ConsolidationContainer
            transactionCode={formData.rptax_transaction_code_id}
          />
        ),
        title: 'Consolidation',
        modalSize: 'modal-xl',
      });
    }
    if (formData.transaction_code === 'DP') {
      setModal({
        isOpen: true,
        content: (
          <DisputeContainer
            transactionCode={formData.rptax_transaction_code_id}
          />
        ),
        title: 'Dispute',
        modalSize: 'modal-xl',
      });
    }
    if (formData.transaction_code === 'TR') {
      setModal({
        isOpen: true,
        content: (
          <TransferOfOwnershipContainer
            transactionCode={formData.rptax_transaction_code_id}
          />
        ),
        title: 'Transfer of Ownership',
        modalSize: 'modal-xl',
      });
    }
    if (formData.transaction_code === 'PC') {
      setModal({
        isOpen: true,
        content: (
          <PhysicalChangeContainer
            transactionCode={formData.rptax_transaction_code_id}
          />
        ),
        title: 'Physical Change',
        modalSize: 'modal-xl',
      });
    }
    if (formData.transaction_code === 'D') {
      setModal({
        isOpen: true,
        content: (
          <DestructionContainer
            transactionCode={formData.rptax_transaction_code_id}
          />
        ),
        title: 'Destruction',
        modalSize: 'modal-xl',
      });
    }
    if (formData.transaction_code === 'R') {
      setModal({
        isOpen: true,
        content: (
          <ReclassificationContainer
            transactionCode={formData.rptax_transaction_code_id}
          />
        ),
        title: 'Reclassification',
        modalSize: 'modal-xl',
      });
    }
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <label htmlFor="last_name" className="form-label mb-0">
            Selection Transaction Code{' '}
            {validateForm.renderMessage('rptax_transaction_code_id')}
          </label>
          <Select
            options={createDropdownRpt(transactionList)}
            value={
              createDropdownRpt(transactionList).find(
                (item) =>
                  _.get(formData, 'rptax_transaction_code_id') ===
                  _.get(item, 'value')
              ) || ''
            }
            onChange={handleOnChangeSelect('rptax_transaction_code_id')}
          />
        </div>
      </div>
      <hr className="below-hr" />
      <div className="d-flex justify-content-center">
        <button
          disabled={!validateForm.response.is_passed}
          onClick={handleOnSubmit}
          type="button"
          className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
        >
          <span className="font-weight-bold">Proceed</span>
        </button>
      </div>
    </Modal.Body>
  );
}

TransactionModal.propTypes = {
  getTransactionCodesList: PropTypes.instanceOf(Function).isRequired,
  transactionList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionList: _.get(api, `${c.GET_TRANSACTION_CODES}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(TransactionModal);
